import React, { useEffect, useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { useDispatch } from 'react-redux'
import styles from './styles'
import { Typography } from '@material-ui/core'
import { AssignmentTypes } from 'src/model/assignment'
import { track } from '@amplitude/analytics-browser'
import { BackButton, CreationCard } from './components'
import NamingModal from 'src/components/naming-modal'
import Options from './data'
import { llmSetChatId } from 'src/reducers/llm/action'
import { llmGetChatMessagesSuccess } from 'src/reducers/llm/action'
import { useLocation } from 'react-router-dom'

const CreateCourseSelection = props => {
  const { classes, history } = props
  const [cardSelection, setCardSelection] = useState()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const collection = searchParams.get('collectionId')
  const dispatch = useDispatch()
  const [showNamingModal, setShowNamingModal] = useState(false)

  const handleClickCard = index => {
    if (index == 0) {
      track('from_scratch')
      setShowNamingModal(true)
      return
    }
    if (index == 1) {
      track('guide_ai_with_description')
      history.push(`/create-course-with-ai?collectionId=${collection}`)
    }
    if (index == 2) {
      track('guide_ai_with_resource')
      history.push(`/create-course-with-ai-use-docs?collectionId=${collection}`)
    }
    setCardSelection(index)
  }
  const handleBackToHome = () => {
    if (cardSelection == 2) {
      setCardSelection(null)
      return
    }
    history.goBack()
  }

  useEffect(() => {
    dispatch(llmSetChatId())
    dispatch(
      llmGetChatMessagesSuccess({
        chatId: null,
        messages: [],
        attachments: [],
      }),
    )
  }, [])

  return (
    <div className={classes.page}>
      <div className={classes.content}>
        <BackButton handleBackToHome={handleBackToHome} />
        <>
          <Typography className={classes.title}>
            How do you want to proceed?
          </Typography>
          <div className={classes.creationCards}>
            {Options.map((option, index) => (
              <CreationCard
                option={option}
                index={index}
                key={index}
                onClick={handleClickCard}
              />
            ))}
          </div>
        </>
      </div>

      {showNamingModal && (
        <NamingModal
          classes={classes}
          dispatch={dispatch}
          id={collection}
          history={history}
          handleCloseModal={() => setShowNamingModal(false)}
          isModalOpen={showNamingModal}
          selectedAssignmentType={AssignmentTypes.ONETIME}
        />
      )}
    </div>
  )
}

export default withStyles(styles)(CreateCourseSelection)
